import { useQuery } from "@tanstack/react-query";
import { fetchCaseSignals } from "../api/caseSignals";

export const caseSignalsKey = (caseId: string) => ["signals", "case", caseId];

export function useCaseSignals(caseId: string) {
  return useQuery({
    queryKey: caseSignalsKey(caseId),
    queryFn: () => fetchCaseSignals(caseId),
    staleTime: 60_000,
    retry: false,
  });
}
